import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { SectionHeights } from './Model';

export default function useModelSectionAligned(modelCount: number, loading: boolean):
  [React.MutableRefObject<(SectionHeights | null)[]>, (SectionHeights | null)] {
  const modelSectionHeightsRefs = useRef<(SectionHeights | null)[]>(
    new Array(modelCount).fill(null)
  );

  const [modelSectionHeights, setModelSectionHeights] = useState<SectionHeights | null>(null);

  useLayoutEffect(() => {
    const updateModelSectionHights = () => {
      const maxNameHeight = Math.max(
        ...modelSectionHeightsRefs.current.map((h) => h?.name || 0)
      );
      const maxSpecsHeight = Math.max(
        ...modelSectionHeightsRefs.current.map((h) => h?.specs || 0)
      );
      const maxFeaturesHeight = Math.max(
        ...modelSectionHeightsRefs.current.map((h) => h?.features || 0)
      );
      const maxDescriptionsHeight = Math.max(
        ...modelSectionHeightsRefs.current.map((h) => h?.descriptions || 0)
      );

      setModelSectionHeights({
        name: maxNameHeight,
        specs: maxSpecsHeight,
        features: maxFeaturesHeight,
        descriptions: maxDescriptionsHeight
      });
    };

    if(!loading){
      updateModelSectionHights();
    }
  }, [
    loading,
    modelSectionHeights?.name,
    modelSectionHeights?.specs,
    modelSectionHeights?.descriptions,
    modelSectionHeights?.features
  ]);

  useEffect(() => {
    const clearModelSectionHeights = () => {
      setModelSectionHeights(null)
    }

    window.addEventListener('resize', clearModelSectionHeights);
    return () => {
      window.removeEventListener('resize', clearModelSectionHeights);
    };
  }, [])

  return [modelSectionHeightsRefs, modelSectionHeights];
}